// Notification system configuration
// Following the existing API configuration patterns

export const NOTIFICATION_CONFIG = {
  // WebSocket endpoint for real-time notifications  
  // Remove /v1 from base URL since Socket.IO path will include it
  WEBSOCKET_URL: import.meta.env.VITE_SERVICE_URL?.replace(/^http/, 'ws').replace(/\/v1$/, '') || 'ws://localhost:8080',
  WEBSOCKET_PATH: '/v1/wss',
  
  // REST API base URL - use existing service URL
  API_BASE_URL: import.meta.env.VITE_SERVICE_URL || 'http://localhost:8080',
  
  // Auto-reconnect settings
  RECONNECT_ATTEMPTS: 5,
  RECONNECT_DELAY: 3000,
  
  // Connection timeout
  CONNECTION_TIMEOUT: 5000,
  
  // Heartbeat interval (30 seconds)
  HEARTBEAT_INTERVAL: 30000,
} as const;

// Notification types based on the updated backend documentation
export const NOTIFICATION_TYPES = {
  FINANCIAL: 'financial',
  HEALTH: 'health',
  EVENTS: 'events',
  GROUPS: 'groups',
} as const;

// Notification priorities
export const NOTIFICATION_PRIORITIES = {
  LOW: 'low',
  MEDIUM: 'medium', 
  HIGH: 'high',
  URGENT: 'urgent',
} as const;

export type NotificationType = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];
export type NotificationPriority = typeof NOTIFICATION_PRIORITIES[keyof typeof NOTIFICATION_PRIORITIES];

// Legacy types for backward compatibility with existing UI
export const LEGACY_NOTIFICATION_TYPES = {
  EVENT_CHANGE: 'events',
  EVENT_CANCELLATION: 'events', 
  HEALTH_ALERT: 'health',
  FINANCIAL: 'financial',
  GROUP_ASSIGNMENT: 'groups',
} as const;
